class Create_Delete_Email_List {
    static path = 'email-actions/create-delete-email-list';

    constructor(mutator){
        this.title = 'Create or Delete an Email List';
        this.addInput("Determining Condition", "boolean");
        this.addInput("List's Email", "email,string");
        this.bgcolor = '#00d1b2';
        this.properties = {operation: ''}
        this.desc = 'Create or Delete an email list';
        this.addWidget("combo", "", '', (v) => {
            this.properties.operation = v;
            if(v === 'Create Email List') {
                this.addOutput("Email List", "email_list");
            } else {
                this.removeOutput("Email List");
            }
        }, {property: "operation", values: ['Create Email List', 'Delete Email List']});
    }

    getTitle() {
        if(this.properties.operation) return this.properties.operation + " Email List";
        return this.title;
    }
}

module.exports = Create_Delete_Email_List
